export default __webpack_public_path__ + "static/media/play.f98e04a5.svg";